export const getAsciiString = (string) => {
  if (!string) return
  return string.replace(
    /[/#=+]/g,
    (charactersToReplace) =>
      ({ '/': '47', '#': '35', '=': '61', '+': '43' }[charactersToReplace])
  )
}
